import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupListTree" */ './lazyIndex');
});
// Delay loaded components
export var GroupListTree = createLazyComponent(lazyModule, function (m) { return m.GroupListTree; });
export var GroupRightCharm = createLazyComponent(lazyModule, function (m) { return m.GroupRightCharm; });
export var GroupRightCharmHover = createLazyComponent(lazyModule, function (m) { return m.GroupRightCharmHover; });
export var GroupContextMenu = createLazyComponent(lazyModule, function (m) { return m.GroupContextMenu; });
export var lazyDropMailListRowsOnGroup = new LazyAction(lazyModule, function (m) { return m.dropMailListRowsOnGroup; });
//# sourceMappingURL=index.js.map